<template>
  <v-container fluid>
    <page-header>
      <template slot="topRightSlot">
        <v-btn depressed elevation="0" class="ml-2 mb-4" color="primary" type="button" :to="{ name: 'CreateAddon' }">{{ $t('add') }}</v-btn>
      </template>
    </page-header>

    <datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :itemTotal="tableTotal"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      actionViewRouteLink="AddonDetail"
      disableToolbar
      @options-update="getList()"
    >
      <template v-slot:[`item.type`]="{ item }">{{ item.type | formatAddonType }}</template>
      <template v-slot:[`item.company_type`]="{ item }">{{ item.company_type | formatCompanyType }}</template>
    </datatable>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
export default {
  name: 'AddonList',
  components: {
    Datatable,
  },
  data: vm => ({
    tableLoading: false,
    tableData: [],
    tableTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
    },
    tableHeaders: [
      { value: 'id', text: 'ID' },
      { value: 'type', text: vm.$t('type') },
      { value: 'company_type', text: vm.$t('companyType') },
      { value: 'name', text: vm.$t('service') },
      { value: 'price', text: vm.$t('price') },
      { value: 'status', text: vm.$t('status') },
      { value: 'actionView', text: '', align: 'end' },
    ],
  }),
  methods: {
    async getList(regenUrl = true) {
      if (regenUrl) {
        this.regenerateURL()
      }

      this.tableLoading = true
      try {
        const payload = {
          filter_page: this.tableFilter.page - 1,
          filter_limit: this.tableFilter.limit,
        }
        const { total, data } = await this.$Fetcher.GetAddons(payload)
        this.tableTotal = total
        this.tableData = data.map(item => {
          return {
            id: item.id,
            type: item.type,
            company_type: item.company_type,
            name: `${item.name_zh}\n${item.name_en}`,
            price: item.price,
            status: item.status
          }
        })
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
      } finally {
        this.tableLoading = false
      }
    },

    getQuery() {
      const query = this.$route.query
      if (Object.keys(query).length > 0) {
        if (this.$validate.DataValid(query.p) && this.$validate.regexNumber(query.p)) {
          this.tableFilter.page = parseInt(query.p)
        }

        if (this.$validate.DataValid(query.l) && this.$validate.regexNumber(query.l)) {
          this.tableFilter.limit = parseInt(query.l)
        }
      }
    },
    regenerateURL() {
      const query = this.$route.query
      let q = {
        p: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        l: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
      }
      const newQuery = this.$common.diffQuery(q, query)
      if (newQuery) {
        this.$router.replace({ query: newQuery })
      }
    },
  },

  async mounted() {
    this.getQuery()
    this.getList(false)
  },
}
</script>
